import { cloneDeep } from 'lodash'
import { UiSchema } from '@rjsf/utils'
import { useSelector } from 'react-redux'
import { AnyObject } from '@feedyou/utils'
import questionStepSchema from '@feedyou/schema/schema/steps/question.json'

import { useFeature } from '../../../../../../store/features'
import { useOpenModalDescriptor, ModalDescriptorForType } from '../../../../../../store/modals'
import { isStepNlpEnabledSelector } from '../../../../../../store/flow/selectors/isStepNlpEnabledSelector'
import {
  HIDDEN_WIDGET,
  WITHOUT_LABEL,
  useBaseSubstepUiSchema
} from '../../../../../../features/schema'

export function useFormSchema() {
  const modalDescriptor = useOpenModalDescriptor() as ModalDescriptorForType<'step_settings'>

  const answerSubstepSchema = cloneDeep<any>(
    modalDescriptor.substepType === 'defaultAnswer'
      ? questionStepSchema.properties.defaultAnswer
      : questionStepSchema.properties.answers.items
  )

  delete answerSubstepSchema.properties.id

  return answerSubstepSchema
}

export function useFormUiSchema(formData: AnyObject): UiSchema {
  const uiSchema = useBaseSubstepUiSchema()
  const isStepNlpEnabled = useSelector(isStepNlpEnabledSelector)
  const isStepNlpDesignerEnabled = useFeature('STEP_NLP_DESIGNER')

  uiSchema.rules = { items: WITHOUT_LABEL }
  uiSchema.synonyms = { items: WITHOUT_LABEL }
  uiSchema.storages = { items: WITHOUT_LABEL }

  if (!isStepNlpEnabled) {
    uiSchema.rules = HIDDEN_WIDGET
  }

  if (isStepNlpEnabled && isStepNlpDesignerEnabled) {
    uiSchema.rules = HIDDEN_WIDGET
    uiSchema.synonyms = HIDDEN_WIDGET
  }

  return uiSchema
}
